<template>
  <div id="container">
    <van-pull-refresh style="padding:0 10px" v-model="refreshing" @refresh="reload">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="加载完成"
        @load="load"
      >
        <div class="card margin-tb-10" v-for="model in models" :key="model.id" @click="openModel(model)">
          <h5>{{model.code}} <span class="pull-right color-describe"><small>{{model.create_time}}</small></span></h5>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    Api.post('wei.user/model', null, res => {
      this.weiUser = res.data
      if (res.data.cusUser !== undefined) this.cusUser = res.data.cusUser
      this.reload()
    })
  },
  data () {
    return {
      weiUser: {},
      cusUser: {},

      models: [],

      filter: {
      },

      loading: false,
      finished: false,
      refreshing: false,

      page: 0
    }
  },
  methods: {
    reload () {
      this.finished = false
      this.loading = true
      this.page = 0
      this.models = []
      this.load()
    },
    load () {
      this.page = this.page + 1
      let params = {page: this.page, status: 10, wor_flow_id: '160416eca98711ec9475afeb8f0a8271', cus_company_id: this.cusUser.cus_company_id}
      Api.post('wor.request/index', params, res => {
        this.models = this.models.concat(res.data)

        this.refreshing = false
        this.loading = false
        if (this.models.length >= res.count) this.finished = true
      })
    },
    openModel (model) {
      this.$router.push('/verify?id=' + model.id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Verifies.vue